// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2Vthx","label":"LabeledBox_label__3I38n"};